module.exports = __webpack_public_path__ + "static/N26-83b39905740a91527e7b7eeafb68f460.jpg";